import { Camera, Heart, Hourglass, UtensilsCrossed } from "lucide-react";
import { Eyebrow, Reveal, SectionTitle } from "./Reveal";
import { CRAFTED_FOR } from "./data";

const ICONS = { Camera, Hourglass, UtensilsCrossed, Heart };

export default function CraftedFor() {
  return (
    <section data-testid="crafted-for-section" className="bg-forest">
      <div className="mx-auto max-w-editorial px-6 py-24 md:px-10 md:py-32">
        <Reveal>
          <Eyebrow tone="saffron" center>
            For the discerning traveller
          </Eyebrow>
        </Reveal>
        <Reveal delay={0.12}>
          <SectionTitle before="Crafted" accent="For" dark center className="mt-7" />
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mx-auto mt-7 h-px w-16 bg-saffron/40" aria-hidden="true" />
        </Reveal>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CRAFTED_FOR.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal
                key={item.index}
                delay={i * 0.08}
                className="group relative border border-ivory/12 bg-ivory/[0.03] p-8 transition-colors duration-500 hover:border-saffron/40"
              >
                <div data-testid={`crafted-for-${item.index}`}>
                  <span className="absolute right-6 top-5 font-serif text-sm italic text-ivory/30">{item.index}</span>
                  <Icon className="h-6 w-6 text-saffron" strokeWidth={1.4} />
                  <h3 className="mt-6 font-serif text-xl font-light leading-snug text-ivory">{item.title}</h3>
                  <p className="mt-3 text-[13px] leading-[1.8] text-ivory/55">{item.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
